import { createEntityReducer } from "@selas/state-management";
import Endpoint from "../../services/api/endpoint";
import { IGroupNote } from "../../utils/types/models";

export default createEntityReducer<IGroupNote>(Endpoint.GroupNotes, Endpoint.GroupNotesList);
